import type { User } from '@/common/types'
import { getAddressString } from '@/common/utils/utils'
import type { ProfileDetailItem } from '../types'

type MfaCopy = {
    label: string
    enabled: string
    notSetUp: string
}

type TrustedDeviceCopy = {
    label: string
    remembered: string
    forget: string
}

type BuildProfileDetailItemsOptions = {
    signedInViaGoogle: boolean
    bffAuthEnabled: boolean
    mfaEnabled: boolean
    mfaCopy: MfaCopy
    hasTrustedDevice: boolean
    trustedDeviceCopy: TrustedDeviceCopy
    onEditPassword: () => void
    onEditMfa: () => void
    onForgetDevice: () => void
}

export const buildProfileDetailItems = (
    user: User,
    {
        signedInViaGoogle,
        bffAuthEnabled,
        mfaEnabled,
        mfaCopy,
        hasTrustedDevice,
        trustedDeviceCopy,
        onEditPassword,
        onEditMfa,
        onForgetDevice,
    }: BuildProfileDetailItemsOptions,
): ProfileDetailItem[] => {
    const items: ProfileDetailItem[] = []

    if (user.firstName && user.lastName) {
        items.push({
            key: 'name',
            label: 'Name',
            value: `${user.firstName} ${user.middleName ? `${user.middleName} ` : ``}${user.lastName}`,
        })
    }

    items.push({ key: 'email', label: 'Email', value: user.emailId })

    if (user.mobile) {
        items.push({ key: 'mobile', label: 'Mobile Number', value: user.mobile })
    }

    if (user.addresses?.residentialAddress) {
        items.push({
            key: 'address',
            label: 'Address',
            value: getAddressString(user.addresses.residentialAddress),
        })
    }

    if (user.addresses?.postalAddress) {
        items.push({
            key: 'postalAddress',
            label: 'Postal Address',
            value: getAddressString(user.addresses.postalAddress),
        })
    }

    if (!signedInViaGoogle) {
        items.push({
            key: 'password',
            label: 'Password',
            value: '•'.repeat(12),
            editHandler: onEditPassword,
        })
    }

    if (bffAuthEnabled) {
        items.push({
            key: 'mfa',
            label: mfaCopy.label,
            value: mfaEnabled ? mfaCopy.enabled : mfaCopy.notSetUp,
            editHandler: mfaEnabled ? undefined : onEditMfa,
        })

        if (hasTrustedDevice) {
            items.push({
                key: 'trustedDevice',
                label: trustedDeviceCopy.label,
                value: trustedDeviceCopy.remembered,
                editHandler: onForgetDevice,
                actionLabel: trustedDeviceCopy.forget,
            })
        }
    }

    return items
}
